import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/agent/sale/list' // 매물목록 조회

const fetchKey = (page, maxData, status, order, searchWord) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${status > 0 ? '&status=' + status : ''}${order && '&order=' + order}${searchWord && '&searchWord=' + searchWord}`;

export function useAgentSaleList(page, maxData, status, order, searchWord,isMobile) {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, status, order, searchWord);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });
	console.log('//data',data);
	 let agentListItems = data?.list;
	 if(isMobile) agentListItems = agentListItems?.filter(item => item.tempStatus === 1) ?? [];

	return { agentSaleList: agentListItems, mutateAgentSaleList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Agent Sale List:', error);
		return { list: [], total: 0 };
	}
}